// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router'

import SectionArtists from '@/views/SectionArtists.vue'
import SectionSearch from '@/views/SectionSearch.vue'
import SectionWhiteCube from '@/views/SectionWhiteCube.vue'
import SectionArtworkCard from '@/views/SectionArtworkCard.vue'
import SectionParenthesis from '@/views/SectionParenthesis.vue'
import SectionAboutUs from '@/views/SectionAboutUs.vue'
import SectionPrivacyNote from '@/views/SectionPrivacyNote.vue'
import SectionContact from '@/views/SectionContact.vue'
import SectionArtistFull from '@/views/SectionArtistFull.vue'
import SectionCookies from '@/views/SectionCookies.vue'
import SectionSubscribe from '@/views/SectionSubscribe.vue'
import SectionLogin from '@/views/SectionLogin.vue'
import SectionProfile from '@/views/SectionProfile.vue'
import SectionPwa from '@/views/SectionPwa.vue'
import SectionRegister from '@/views/SectionRegister.vue'

export const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        { path: '/', name: 'parenthesis', component: SectionParenthesis },
        { path: '/artists/:display?', name: 'artists', component: SectionArtists, props: true },
        { path: '/artist/:id', name: 'artistfull', component: SectionArtistFull, props: true },
        { path: '/search', name: 'search', component: SectionSearch },
        { path: '/cube', name: 'cube', component: SectionWhiteCube },
        { path: '/artwork/:id', name: 'artworkcard', component: SectionArtworkCard, props: true },
        { path: '/about', name: 'about', component: SectionAboutUs },
        { path: '/privacy', name: 'privacy', component: SectionPrivacyNote },
        { path: '/contact/:id', name: 'contact', component: SectionContact, props: true },

        { path: '/cookies', name: 'cookies', component: SectionCookies },
        { path: '/subscribe', name: 'subscribe', component: SectionSubscribe },
        { path: '/login', name: 'login', component: SectionLogin },
        { path: '/register', name: 'register', component: SectionRegister },
        { path: '/profile', name: 'profile', component: SectionProfile },
        { path: '/pwa', name: 'pwa', component: SectionPwa },
    ],
})